<template>
  <IQOS :title="$t('delivery_shipping_time.title')" :readonly="editing">
      <BaseInput :value="`${shipping_time} ${$t('units.mins')}`" v-if="!editing"/>
      <BaseInput type="number" :readonly="false" :valid="shipping_time != '' && shipping_time > 0" v-model.number="shipping_time" v-else/>
      <p class="comment c-grey" v-if="editing">
          {{ $t('delivery_shipping_time.comment') }}
      </p>

      <IQOSActions :editing="editing" @edit="showEditUI" @accept="onEditFinish" @cancel="hideEditUI" />
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'
import IQOSActions from '@/components/IQOSActions.vue'

import BlackInput from '@/components/BlackInput.vue'

export default {
    data() {
        return {
            editing: false,

            shipping_time: 15,
        }
    },
    methods: {
        reset() {
            this.shipping_time = this.cafe.delivery.shipping_time || 15;
        },
        showEditUI() {
            this.editing = true;
        },
        hideEditUI() {
            this.editing = false;
            this.reset();
        },
        onEditFinish() {
            if (!this.shipping_time) return;

            this.$store.commit('setDeliveryShippingTime', this.shipping_time);
            this.$store.dispatch('saveCafe');
            this.editing = false;
        } 
    },
    mounted() {
        this.reset();
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    },
    components: {
        IQOS,
        IQOSActions,
        BlackInput
    }
}
</script>

<style>

</style>